import React from 'react'
import { Box, Typography } from '@mui/material'

import { InspectionDetail } from '../MoveOut/types'

interface MoveOutVideosSectionProps {
    inspections: InspectionDetail[]
}

export const MoveOutVideosSection: React.FC<MoveOutVideosSectionProps> = ({
    inspections,
}) => {
    const videos = inspections.flatMap((inspection) =>
        (inspection.videos ?? []).map((video) => ({
            ...video,
            area_name: inspection.area_name,
        })),
    )

    if (videos.length === 0) {
        return null
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {videos.map((video) => (
                <Box
                    key={video.id}
                    sx={{
                        border: '1px solid rgba(255, 255, 255, 0.08)',
                        borderRadius: 2,
                        overflow: 'hidden',
                    }}
                >
                    <Box
                        sx={{
                            px: 2,
                            py: 1.5,
                            backgroundColor: 'rgba(255, 255, 255, 0.04)',
                        }}
                    >
                        <Typography
                            variant="body2"
                            sx={{ fontWeight: 600, color: '#fff' }}
                        >
                            Inspection Video — {video.area_name}
                        </Typography>
                    </Box>
                    <Box sx={{ backgroundColor: '#000' }}>
                        <video
                            controls
                            style={{
                                width: '100%',
                                maxHeight: 400,
                                display: 'block',
                            }}
                        >
                            <source src={video.url} />
                        </video>
                    </Box>
                </Box>
            ))}
        </Box>
    )
}
